import * as UserApiUtil from "../../util/user_util";
import * as DeviceApiUtil from "../../util/device_util"
import * as NotificationAPIUtil from '../../util/notification_util'
export const RECEIVE_USER_PROFILE = "RECEIVE_USER_PROFILE"
export const RECEIVE_DEVICE_PROFILE = "RECEIVE_DEVICE_PROFILE"
export const RECEIVE_USER_PROFILE_NOTIFICATIONS = "RECEIVE_USER_PROFILE_NOTIFICATIONS"
export const RECEIVE_USER_FEEDBACK = "RECEIVE_USER_FEEDBACK"
const receiveUserProfile = (user) => {
    return {
        type: RECEIVE_USER_PROFILE,
        user
    }
}

const receiveDeviceProfile = (device) => {
    return {
        type: RECEIVE_DEVICE_PROFILE,
        device
    }
}

export const receiveUserNotifications = (notifications) => {
    return {
        type: RECEIVE_USER_PROFILE_NOTIFICATIONS,
        notifications
    }
};

export const receiveUserFeedback = (feedback) => {
    return {
        type: RECEIVE_USER_FEEDBACK,
        feedback
    }
};

export const fetchUserProfile = (userId, cancelToken) => dispatch => {
    return UserApiUtil.fetchUser(userId, cancelToken)
        .then(user => dispatch(receiveUserProfile(user)))
};

export const fetchDeviceProfile = (deviceId, cancelToken) => dispatch => {
    return DeviceApiUtil.fetchDevice(deviceId, cancelToken)
        .then(device => { dispatch(receiveDeviceProfile(device)) })
};

export const editDeviceNickname = (id, nickname) => dispatch => {
    return DeviceApiUtil.editDeviceNickname(id, nickname)
        .then(device => { dispatch(receiveDeviceProfile(device.data))})
}
export const setDeviceAuthorization = (id, authorization) => dispatch => {
    return DeviceApiUtil.setDeviceAuthorization(id, authorization)
        .then(device => { dispatch(receiveDeviceProfile(device.data))})
}

export const editDeviceType = (id, type) => dispatch => {
    return DeviceApiUtil.editDeviceType(id, type)
        .then(device => { dispatch(receiveDeviceProfile(device.data))})
}

export const fetchUserNotifications = (username, cancelToken) => dispatch => (
    NotificationAPIUtil.fetchUserNotifications(username, cancelToken)
        .then(notifications => dispatch(receiveUserNotifications(notifications)))
);

export const fetchUserFeedback = (username, cancelToken) => dispatch => (
    UserApiUtil.fetchUserFeedback(username, cancelToken)
        .then(feedback => dispatch(receiveUserFeedback(feedback)))
);